<template>
  <section>
    <div class="level-left">
      <BreadCrumbList class="level-item">
        <span>{{this.groupName}}</span>
        <span>{{this.$t("app.dashboard.sidemenu.member")}}</span>
      </BreadCrumbList>
    </div>
    <div class="table-box">
      <CommonTable
        :data="members"
        :config="tableConfig"
        :selected.sync="selectedGroup">
         <template slot-scope="props">
            <b-table-column field="name" :label="$t('app.dashboard.member.membername')"  sortable>
                {{props.row.name}}
            </b-table-column>
            <b-table-column field="id" :label="$t('app.dashboard.member.memberid')" sortable>
                {{ props.row.id}}
            </b-table-column>
          </template>
      </CommonTable>
    </div>
    <ul class="btn-list">
      <li v-if="isOwned"><a @click="inviteUser()" class="btn"><i class="fas fa-user-plus"></i>{{$t('app.dashboard.sidemenu.plus.addmember')}}</a></li>
    </ul>
    <b-modal :active.sync="modal.active" has-modal-card>

      <div class="popup-token">
        <h3 class="popup-title"><i class="fas fa-key"></i>{{$t('app.dashboard.sidemenu.plus.groupconnecttoken')}}</h3>
        <p class="token-number">{{modal.number}}</p>
        <p class="token-expire"><i class="far fa-clock"></i>{{$t('app.dashboard.sidemenu.plus.tokenexpire')}}<span class="remaining-time">{{modal.expire}}</span></p>
        <!-- <a href="#" class="popup-close-btn">close</a> -->
      </div>
    </b-modal>
  </section>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import moment from 'moment'
import GroupSelectHandler from './GroupSelectHandler'
import BreadCrumbList from '../../../view/BreadCrumbList'
import CommonTable from '../../../view/CommonTable'

export default GroupSelectHandler.extend({
  components: {BreadCrumbList, CommonTable},
  data() {
    return {
      columns: [
        {
          field: "name",
          label: this.$t("userlist.memberlist"),
        },
        {
          field: "id",
          label: "ID",
        },
      ],
      tableConfig: {
          checkable: false,
          defaultSort: ['name','asc'],
          striped: false
      },
      modal: {
        active: false,
        number: null,
        expire: null
      }
    }
  },
  computed: {
    ...mapState({
      isOwned: state => state.groups.selected && state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].OwnerID === state.account.id,
      groupName: state => state.groups.selected && state.groups.cached[state.groups.selected] && state.groups.cached[state.groups.selected].Name,
      members: state => {
          if (state.groups.cached[state.groups.selected]) {
            return state.groups.cached[state.groups.selected].Members.map(i => {return {id: i.UserID, name: i.Name}})
          } else {
            return []
          }
      }
    })
  },
  methods: {
    inviteUser() {
      this.inviteGroup(this.selectedGroup)
      .then((con) => {
        this.modal.number = con.ConnectionID
        const intervalID = setInterval(() => {
          if (!this.modal.active) { // modalが非activeのときはintervalループを止める
            clearInterval(intervalID)
            return
          }

          const diff = moment.duration(moment.unix(con.exp).diff(moment()))
          const m = diff.minutes()
          const s = diff.seconds()
          if (m+s === 0) {
            clearInterval(intervalID)
            this.inviteUser()
            return
          }
          this.modal.expire = m + ':' + ((('' + s).length === 2)? s : '0' + s)
        }, 1000)
        this.modal.active = true
      })
      .catch(() => { 
        this.$buefy.toast.open({
          duration: 7000,
          message: this.$t('app.dashboard.graph.error_warning'),
          position: "is-top",
          type: "is-danger"
        })
        return Promise.resolve()
      })
    },
    ...mapActions({
      'inviteGroup': 'groups/inviteGroup'
    })
  }
})
</script>

<style scoped>
.popup-token {
  position: fixed;
  width: 600px;
  padding: 30px 30px 60px 30px;
  z-index: 20;
  background: #fff;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}
.popup-title {
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 30px;
  font-size: 1.25rem;
  font-weight: bold;
  letter-spacing: .05em;
  border-bottom: 1px solid #ccc;
}
.popup-title i {
  margin-right: .5em;
}

.token-number {
  margin-bottom: 30px;
  font-size: 3.75rem;
  font-family: 'Roboto Mono', monospace;
  letter-spacing: .3em;
  text-align: center;
}

.token-expire {
  text-align: center;
}

.popup-close-btn {
  position: absolute;
  bottom: 15px;
  right: 15px;
  font-size: 0;
  color: #999;
  text-decoration: none;
}
.popup-close-btn:before {
  font-family: 'Font Awesome 5 Free';
  content: "\f00d";
  font-weight: 900;
  font-size: 1.3752.2rem;
}

.remaining-time {
  margin-left: 10px;
  color: #428BCA;
  font-size: 1.5625rem;
}

.table-box {
  width: 100%;
  background: #fff;
  margin: 35px 0;
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-list li {
  margin: 10px 15px;
}
.btn {
  display: block;
  position: relative;
  padding: 15px 20px 15px 55px;
  border-radius: 4px;
  background: #2c6ac4;
  color: #fff;
  text-decoration: none;
  font-size: 0.9375rem;
}
.btn i {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  font-size: 1.375rem;
}
</style>
